import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./portfolio.css";

// projects Files
import Lamahealth from "../../assets/portfolio/projects02.png";
import SavioProject from "../../assets/portfolio/projects04.png";
import BdaunaniProject from "../../assets/portfolio/projects05.png";
import HideandSeekProject from "../../assets/portfolio/projects07.png";
import DoorpayProject from "../../assets/portfolio/projects8.png";
import EcommerceWebsite from "../../assets/portfolio/projects03.png";
import YpredictProject from "../../assets/portfolio/YPredict-v1.jpg";
import TravellingProject from "../../assets/portfolio/travelling.png";
// import ReactAdminImage from "../../assets/portfolio/reactAdminImage.png";

const projects = [
  {
    img: Lamahealth,
    title: "Lama Health",
    description:
      "A healthcare web platform providing advanced telemedicine solutions and patient management.",
    services: "Web Services",
    live: "https://lamahealth.com",
    stack: ["React", "Next.js", "Node.js", "MongoDB"],
    image: Lamahealth,
  },
  {
    img: SavioProject,
    title: "Savio",
    description:
      "An AI-powered education platform enabling personalized learning experiences for students.",
    services: "Web Services",
    live: "https://saveodev-6d98f.web.app",
    stack: ["React", "Express", "PostgreSQL", "TailwindCSS"],
    image: SavioProject,
  },
  {
    img: BdaunaniProject,
    title: "Bdaunani",
    description:
      "An e-commerce platform for modern businesses, built with responsive UI and secure payments.",
    services: "Web Services",
    live: "https://bdaunani.org",
    stack: ["Shopify", "React", "Stripe API"],
    image: BdaunaniProject,
  },
  {
    img: HideandSeekProject,
    title: "Hide & Seek",
    description:
      "A fun gaming app delivering immersive experiences with engaging UI/UX designs.",
    services: "App Development",
    live: "https://hideandset.com/",
    stack: ["Unity", "React Native", "Firebase"],
    image: HideandSeekProject,
  },
  {
    img: DoorpayProject,
    title: "Doorpay",
    description:
      "A smart payment solution designed for fast, secure, and hassle-free digital transactions.",
    services: "Fintech Solutions",
    live: "https://doorpay.io",
    stack: ["React", "Next.js", "Blockchain", "Node.js"],
    image: DoorpayProject,
  },
  {
    img: TravellingProject,
    title: "TravelMate",
    description:
      "A travel booking website offering personalized itineraries and real-time booking features.",
    services: "Web Services",
    live: "https://travelmate.com",
    stack: ["React", "Next.js", "GraphQL", "TailwindCSS"],
    image: TravellingProject,
  },
  {
    img: YpredictProject,
    title: "Ypredict",
    description:
      "AI-based market prediction platform designed for investors and financial analysts.",
    services: "AI + Web",
    live: "https://ubiquitous-bublanina-da84ec.netlify.app",
    stack: ["React", "Next.js", "TensorFlow.js", "Node.js"],
    image: YpredictProject,
  },
  {
    img: EcommerceWebsite,
    title: "Ecommerce",
    description:
      "A scalable e-commerce store with product catalogs, cart, and integrated payment gateway.",
    services: "E-Commerce",
    live: "https://treemendous-b4924.web.app",
    stack: ["React", "Next.js", "Stripe", "MongoDB"],
    image: EcommerceWebsite,
  },
  // {
  //   img: ReactAdminImage,
  //   title: "Ecommerce",
  //   description:
  //     "A scalable e-commerce store with product catalogs, cart, and integrated payment gateway.",
  //   services: "E-Commerce",
  //   live: "https://react-pwa-119a2.web.app/",
  //   stack: ["React", "Next.js", "Stripe", "MongoDB"],
  //   image: ReactAdminImage,
  // },
];

const PortfolioTitle = () => (
  <>
    <h5 className="industriesTitle" data-aos="fade-down">
      -- Our Completed Projects
    </h5>
    <h1 className="portfolioHeading" data-aos="fade-up">
      Our Portfolio! –{" "}
      <span className="subHeading"> Turning Ideas into Reality </span>
    </h1>
  </>
);

const PortfolioDescription = () => (
  <div className="portfolioDescriptionContainer" data-aos="fade-up">
    <p className="portfoliomainDescription">
      At StarlinkLab, we take pride in delivering high-quality, innovative
      solutions that help businesses grow and succeed. From startups to
      enterprises, our projects span across industries, showcasing our expertise
      in web development, mobile apps, UI/UX design, and e-commerce solutions.
    </p>
    <p className="portfolioQuote">
      "Real impact, proven expertise—our work drives success across industries."
    </p>
  </div>
);

const PortfolioGrid = () => (
  <div className="portfolioGrid">
    {projects.map((project, index) => (
      <div className="flip-card" key={index} data-aos="zoom-in">
        <div className="flip-card-inner">
          {/* Front Side */}
          <div className="flip-card-front">
            <img
              src={project.img}
              alt={project.title}
              className="portfolioImage"
              style={{ borderRadius: "10px 10px 0 0" }}
            />
          </div>

          {/* Back Side */}
          <div className="flip-card-back">
            <div className="cardContent">
              <a
                href={project.live}
                target="_blank"
                rel="noopener noreferrer"
                className="projectLink"
              >
                {project.live.replace("https://", "www.")}
              
              </a>
               <br/>
              <h3 className="projectTitle">{project.title}</h3>
              <p className="projectDescription">
                At <span>{project.title}</span>, I played a crucial role in
                developing frontend and backend components for their
                <span className="highlight"> web/mobile application </span>{" "}
                using React/Next.
              </p>
              <div className="techStack">
                {project.stack.map((tech, idx) => (
                  <span key={idx} className="techTag">
                    {tech}
                  </span>
                ))}
              </div>
            </div>
            <div className="cardImage">
              <img src={project.image} alt={project.title} className="backSideImage"/>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
);

function PortfolioSection() {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 120,
    });
  }, []);

  return (
    <>
      <link
        href="https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;500;700&family=Satisfy&display=swap"
        rel="stylesheet"
      />
      <section className="portfolioSection">
        <div className="portfolioContainer">
          <PortfolioTitle />
          <PortfolioDescription />
          <PortfolioGrid />
        </div>
      </section>
    </>
  );
}

export default PortfolioSection;
